module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ip),
      expression: "ip"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "IP adresa"
    },
    domProps: {
      "value": (_vm.ip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ip = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nickname),
      expression: "nickname"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Nickname"
    },
    domProps: {
      "value": (_vm.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.server),
      expression: "server"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-server"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.server = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.role >= 33) ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Server: Svi")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 21) ? _c('option', {
    attrs: {
      "value": "StartGame FFA#1"
    }
  }, [_vm._v("StartGame FFA#1")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 21) ? _c('option', {
    attrs: {
      "value": "Spec FFA#1"
    }
  }, [_vm._v("Spec FFA#1")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 22) ? _c('option', {
    attrs: {
      "value": "StartGame MINIONS#2"
    }
  }, [_vm._v("StartGame MINIONS#2")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 22) ? _c('option', {
    attrs: {
      "value": "Spec MINIONS#2"
    }
  }, [_vm._v("Spec MINIONS#2")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 23) ? _c('option', {
    attrs: {
      "value": "StartGame INSTANT MERGE#3"
    }
  }, [_vm._v("StartGame INSTANT MERGE#3")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 23) ? _c('option', {
    attrs: {
      "value": "Spec INSTANT MERGE#3"
    }
  }, [_vm._v("Spec INSTANT MERGE#3")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 24) ? _c('option', {
    attrs: {
      "value": "StartGame MEGA SPLIT#4"
    }
  }, [_vm._v("StartGame MEGA SPLIT#4")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 24) ? _c('option', {
    attrs: {
      "value": "Spec MEGA SPLIT#4"
    }
  }, [_vm._v("Spec MEGA SPLIT#4")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 25) ? _c('option', {
    attrs: {
      "value": "StartGame EXPERIMENTAL#5"
    }
  }, [_vm._v("StartGame EXPERIMENTAL#5")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 25) ? _c('option', {
    attrs: {
      "value": "Spec EXPERIMENTAL#5"
    }
  }, [_vm._v("Spec EXPERIMENTAL#5")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 26) ? _c('option', {
    attrs: {
      "value": "StartGame RAINBOW#6"
    }
  }, [_vm._v("StartGame RAINBOW#6")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 26) ? _c('option', {
    attrs: {
      "value": "Spec RAINBOW#6"
    }
  }, [_vm._v("Spec RAINBOW#6")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 27) ? _c('option', {
    attrs: {
      "value": "StartGame VIRUS MINES#7"
    }
  }, [_vm._v("StartGame VIRUS MINES#7")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 27) ? _c('option', {
    attrs: {
      "value": "Spec VIRUS MINES#7"
    }
  }, [_vm._v("Spec VIRUS MINES#7")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 28) ? _c('option', {
    attrs: {
      "value": "StartGame OLD EXP#8"
    }
  }, [_vm._v("StartGame OLD EXP#8")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 28) ? _c('option', {
    attrs: {
      "value": "Spec OLD EXP#8"
    }
  }, [_vm._v("Spec OLD EXP#8")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
    attrs: {
      "value": "StartGame TOURNAMENT#9"
    }
  }, [_vm._v("StartGame TOURNAMENT#9")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
    attrs: {
      "value": "Spec TOURNAMENT#9"
    }
  }, [_vm._v("Spec TOURNAMENT#9")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
    attrs: {
      "value": "StartGame TOURNAMENT#10"
    }
  }, [_vm._v("StartGame TOURNAMENT#10")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
    attrs: {
      "value": "Spec TOURNAMENT#10"
    }
  }, [_vm._v("Spec TOURNAMENT#10")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resolution),
      expression: "resolution"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "resolution",
      "placeholder": "Rezolucija npr: 1000x600"
    },
    domProps: {
      "value": (_vm.resolution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resolution = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "form-control",
    attrs: {
      "type": "button",
      "id": "browser"
    },
    on: {
      "click": function($event) {
        _vm.browserToggleClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.browserToggle()))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [_c('label', [_vm._v("Početni datum")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start),
      expression: "start"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("Završni datum")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end),
      expression: "end"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "endDate"
    },
    domProps: {
      "value": (_vm.end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("Vreme")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hours),
      expression: "hours"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "hours",
      "placeholder": "00"
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = $event.target.value
      }
    }
  }), _vm._v(" :\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minute),
      expression: "minute"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "minute",
      "placeholder": "30"
    },
    domProps: {
      "value": (_vm.minute)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minute = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.realTime()
      }
    }
  }, [_vm._v("Sada")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        _vm.queryReports()
      }
    }
  }, [_vm._v("Pretraži")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Server")]), _vm._v(" "), _c('td', [_vm._v("Nick")]), _vm._v(" "), _c('td', [_vm._v("IP adresa")]), _vm._v(" "), _c('td', [_vm._v("Grad/Zemlja")]), _vm._v(" "), _c('td', [_vm._v("Sistem")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.browserToggle()) + "/Rezolucija")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.result), function(col) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(col.dimensions[2]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[3]) + ", " + _vm._s(col.dimensions[4]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[5]) + ", " + _vm._s(col.dimensions[6]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[7]) + " / " + _vm._s(col.dimensions[8]))])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n            Google analitika\n            "), _c('small', [_c('p', {
    staticClass: "g-signin2",
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "data-onsuccess": "queryReports"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-000eaa9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/analytic/index.vue
// module id = 301
// module chunks = 2